const Cache = {
    set: (key = 'key', value = 'value', ttl = 0) => {
        if (!window.localStorage) {
            return false;
        }

        const data = {
            expire: Date.now() + ttl * 1000,
            value
        };

        localStorage.setItem(key, JSON.stringify(data));

        return true;
    },

    get: (key) => {
        if (!window.localStorage) {
            return false;
        }
        let data = localStorage.getItem(key);

        if (!data) {
            return false;
        }

        data = JSON.parse(data);

        if (data.expire < Date.now()) {
            return false;
        }

        return data.value;
    },

    remove: (key) => {
        localStorage.removeItem(key);
    }
};

export default Cache;
